function hasMegaMenu(pageDescriptor) {
  if (!pageDescriptor) {
    return false;
  }
  if (pageDescriptor.parentId) {
    return false;
  }
  return pageDescriptor.megaMenu.hasMegaMenu;
}

export { hasMegaMenu };
//# sourceMappingURL=descriptor.has-megamenu.js.map
